/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { showModal, getEvolutionPlanTrainingPreRequisites } from "actions";
import EvolutionPlanPreRequisiteBody, {
  EvolutionPlanPreRequisiteTitle,
} from "components/evolutionPlan/EvolutionPlanPreRequisite";
import { Trans } from "react-i18next";

class EvolutionPlanPlans extends Component {
  embedClassName = (evolutionPlanStatus) => {
    if (evolutionPlanStatus === "Success") return "tamamlanmisEgitim";
    if (evolutionPlanStatus === "Fail") return "tekrarlanmasiGerekenEgitim";
    if (evolutionPlanStatus === "Registered") return "kayitliEgitim";
  };

  renderPrerequisiteModal = (trainingId, trainingName) => {
    this.props.showModal({
      modalType: "epPreReq",
      modalTitle: <EvolutionPlanPreRequisiteTitle />,
      modalContent: (
        <EvolutionPlanPreRequisiteBody
          employeeId={this.props.employeeId}
          trainingId={trainingId}
          trainingName={trainingName}
        />
      ),
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  renderIcon = (plan) => {
    if (plan.fordRole === true)
      return <span className="icon-icon-fordrol mr-1"></span>;
    else if (plan.targetedPosition === true)
      return <span className="icon-icon-menu-vision1 mr-1"></span>
    else return null;
  };

  renderDetail = () => {
    let arr = this.props.plans;
    if (!this.props.showCompleted) {
      arr = arr.filter((p) => p.success === false);
    }
    return arr.map((plan) => {
      return (
        <tr
          key={plan.training.id}
          className={this.embedClassName(plan.evolutionPlanStatus)}
        >
          <td className="showGrup">



            {plan.programTypeCode == 0
              ? plan.method?.label
              : <strong style={{
                display: "inline-flex",
                alignItems: "center",
                "gap": "8px"
              }} >

                <svg
                  // viewBox="0 0 360 483.3"
                  viewBox="100 100 200 200"
                  style={{
                    width: 40,
                    margin: "0 auto",
                    height: "auto",
                    boxSizing: "border-box",
                    minWidth: "40px"
                  }}
                >
                  <title>Ford Pro Logo</title>


                  <g>
                    <g>
                      <path
                        fill="#00095B"
                        d="M107.1904297,166.3092499h18.6459961c14.2714844,0,21.9453125,6.8847656,21.9453125,18.4316406
          c0,10.8291016-8.7495117,17.4267578-19.1484375,17.4267578h-9.9682617v17.2119141h-11.4746094V166.3092499z
          M126.7685547,192.1276093c6.0961914,0,9.0366211-2.1513672,9.0366211-7.8173828
          c0-6.3105469-3.7294922-7.9609375-10.184082-7.9609375h-6.9560547v15.7783203H126.7685547z"
                      />

                      <path
                        fill="#00095B"
                        d="M154.015625,166.3092499h19.3632812c14.1992188,0,21.9453125,4.8769531,21.9453125,16.0644531
          c0,5.953125-2.2949219,9.8251953-6.5976562,12.4785156
          c4.2304688,1.3632812,6.3818359,5.0917969,6.3818359,9.6103516v14.9169922
          h-11.4746094v-13.6259766c0-4.0878906-1.9355469-5.3789062-5.378418-5.3789062h-12.7651367v19.0048828H154.015625V166.3092499z
          M174.3110352,191.0514374c6.1674805,0,9.0366211-1.8642578,9.0366211-7.7451172
          c0-5.59375-3.8012695-6.9570312-10.184082-6.9570312h-7.6733398v14.7021484H174.3110352z"
                      />

                      <path
                        fill="#00095B"
                        d="M201.9306641,193.2028046c0-18.1435547,11.4746094-27.6103516,26.0332031-27.6103516
          c14.4873047,0,24.6708984,9.4667969,24.6708984,26.75
          c0,18.0722656-11.3310547,27.7539062-25.9619141,27.7539062
          C212.1865234,220.0963593,201.9306641,210.5582733,201.9306641,193.2028046z
          M226.8164062,210.0563202c9.0361328,0,13.9130859-6.3105469,13.9130859-17.3554688
          c0-10.3984375-4.2314453-17.0683594-13.1953125-17.0683594
          c-9.0371094,0-13.7695312,6.5976562-13.7695312,17.7138672
          C213.7646484,204.0319061,218.1386719,210.0563202,226.8164062,210.0563202z"
                      />
                    </g>

                    <g>
                      <path
                        fill="#00095B"
                        d="M255.515625,167.9781952h-3.1474609v-1.7070312h8.125v1.7070312h-3.1464844v7.6923828h-1.8310547V167.9781952z
          M261.3779297,166.2711639h2.0566406l2.859375,6.9521484l2.859375-6.9521484h2.0566406v9.3994141h-1.7900391v-6.2119141
          l-2.5292969,6.2119141h-1.234375l-2.5507812-6.2119141v6.2119141h-1.7275391V166.2711639z"
                      />
                    </g>

                    <rect x="107.2" y="231.9" fill="#1700F4" width="144.8" height="15.6" />
                  </g>
                </svg>


                <strong> {plan.method?.label} </strong>

              </strong>
            }





          </td>
          <td className="showGrup">
            {this.renderIcon(plan)}
            {plan.training?.name}
          </td>
          <td className="showGrup">{plan.location}</td>
          <td className="showGrup">
            {plan.duration}
            <sup>
              <Trans desc="GÜN">10388</Trans>
            </sup>
          </td>
          <td className="showGrup">
            {plan.score}
          </td>
          <td className="showGrup">{plan.weight.toFixed(2)}</td>
          <td className="showGrup">{plan.futureWeight.toFixed(2)}</td>
          <td>
            {plan.havePreRequisite ? (
              <a
                onClick={() =>
                  this.renderPrerequisiteModal(
                    plan.training.id,
                    plan.training.name
                  )
                }
                className="btn btn-fga-view"
              >
                <Trans desc="Göster">10143</Trans>{" "}
                <span className="iconmford fo-icon-search" style={{ fontSize: 0 }}></span>
              </a>
            ) : null}
          </td>
          <td></td>
        </tr>
      );
    });
  };

  render() {
    return (
      <tr>
        <td>
          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="row pb-3">
                {/* <div className="col-xs-12 col-sm-12 offset-md-10 col-md-2 offset-lg-10 col-lg-2 tableSearchArea">
                  <div className="inner-addon right-addon">
                    <span className="iconmford fo-icon-search"></span>
                    <input
                      type="text"
                      name="tableSearch"
                      id="tableSearch"
                      className="form-control"
                      placeholder="Bul"
                    />
                  </div>
                </div> */}
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
                  <table className="table display responsive kE">
                    <thead>
                      <tr>
                        <th className="all">
                          <div className="tableTitle">
                            <Trans desc="Tür">10014</Trans>
                          </div>
                        </th>
                        <th className="all">
                          <div className="tableTitle">
                            <Trans desc="Eğitim Adı">10015</Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Yer">10016</Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Süre">10017</Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Skor">10609</Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Mevcut Dönem Eğitim Ağırlığı">
                              10513
                            </Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Gelecek Dönem Eğitim Ağırlığı">
                              10514
                            </Trans>
                          </div>
                        </th>
                        <th className="desktop">
                          <div className="tableTitle">
                            <Trans desc="Ön Şart">10159</Trans>
                          </div>
                        </th>
                        <th className="none"></th>
                      </tr>
                    </thead>
                    <tbody>{this.renderDetail()}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    modal: state.modal,
    application: state.application,
    plans: state.evolutionPlan.data.evolutionPlans.find(
      (p) => p.level.id === ownProps.id
    )?.plans,
  };
};

export default connect(mapStateToProps, {
  showModal,
  getEvolutionPlanTrainingPreRequisites,
})(EvolutionPlanPlans);
